module.exports = __webpack_public_path__ + "static/img/P6.ef60d07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mszj/P6.png
// module id = TPxb
// module chunks = 0